let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bY8qa")).then(() => parcelRequire('6ZR0a'));